function getPictureAnalysisUrl(picture) {
  return picture?.publicUrlSmall || picture?.publicUrlThumbnail || picture?.publicUrl || '';
}

async function downloadPictureForAnalysis(picture) {
  const url = getPictureAnalysisUrl(picture);
  if (!url) throw new Error('照片缺少可分析的预览地址');

  const response = await fetch(url, {
    cache: 'force-cache',
    credentials: 'omit',
    mode: 'cors',
  });
  if (!response.ok) throw new Error(`照片预览下载失败（${response.status}）`);

  const blob = await response.blob();
  const name = picture.originalFileName || picture.fileName || `photo-${picture.id}.jpg`;
  return new File([blob], name, {
    type: blob.type || 'image/jpeg',
    lastModified: Date.now(),
  });
}

function summarizeOrderQuality(results, failures = 0) {
  const list = results || [];
  const closed = list.filter(result => result.faceAnalysis?.closedEyeFaces > 0).length;
  const blur = list.filter(result => result.sharpness?.isBlurry).length;
  const exposure = list.filter(result => Boolean(result.exposure?.issue)).length;
  const duplicate = list.filter(result => result.isDuplicateAlternative).length;
  const partial = list.filter(result => result.faceAnalysis?.status === 'unavailable').length;
  const review = list.filter(result => (
    result.faceAnalysis?.closedEyeFaces > 0
    || result.sharpness?.isBlurry
    || Boolean(result.exposure?.issue)
    || result.isDuplicateAlternative
  )).length;
  const clean = Math.max(0, list.length - review);
  const reviewRate = list.length ? review / list.length : 0;

  let verdict = '扫描完成，可以开始复核';
  let tone = 'neutral';
  if (list.length && review === 0 && failures === 0) {
    verdict = '整体状态良好，未发现明显问题';
    tone = 'good';
  } else if (reviewRate >= 0.2 || closed + blur >= 5) {
    verdict = '发现较多风险照片，建议优先集中复核';
    tone = 'warning';
  } else if (review > 0) {
    verdict = '发现少量风险照片，建议快速复核';
    tone = 'attention';
  } else if (failures > 0) {
    verdict = '部分照片未完成，请重新扫描';
    tone = 'warning';
  }

  return { total: list.length, review, clean, closed, blur, exposure, duplicate, partial, failures, reviewRate, verdict, tone };
}

export { downloadPictureForAnalysis, getPictureAnalysisUrl, summarizeOrderQuality };
